import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'add-button',
  imports: [ButtonModule],
  templateUrl: './add-button.component.html',
  styleUrl: './add-button.component.scss',
})
export class AddButtonComponent {
  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() ariaLabel: string = '';
  @Output() clicked = new EventEmitter<void>();
}
